// extracted by mini-css-extract-plugin
module.exports = {"root":"_1xcu2","buttonsContainer":"_1djcJ","button":"_3Q3GM","header":"_3pa10"};